export type WhatsNewSlotDecision = 'pending' | 'released' | 'claim';

export interface WhatsNewSlotInput {
  /** Runtime flag resolved (or local dev). */
  decided: boolean;
  /** Flag on for this signed-in subscriber. */
  enabled: boolean;
  /** Unread query settled with data. */
  loaded: boolean;
  /** Unread query failed. */
  failed: boolean;
  unreadCount: number;
  /** Current route is a playback surface. */
  suppressed: boolean;
  /** Current route is /whats-new — the page itself marks everything read. */
  onHistoryPage: boolean;
  /** The host waited long enough for flag + fetch. */
  timedOut: boolean;
}

/**
 * Whether What's New holds the session's prompt slot. A slow flag or fetch
 * releases on timeout so the other prompts are never blocked by a hung request;
 * a known unread set on a playback route keeps waiting (the other prompts are
 * suppressed there too) and claims as soon as the user leaves.
 */
export function decideWhatsNewSlot(input: WhatsNewSlotInput): WhatsNewSlotDecision {
  if (!input.decided) return input.timedOut ? 'released' : 'pending';
  if (!input.enabled || input.failed) return 'released';
  if (!input.loaded) return input.timedOut ? 'released' : 'pending';
  if (input.unreadCount === 0 || input.onHistoryPage) return 'released';
  return input.suppressed ? 'pending' : 'claim';
}
